/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';


const TagWithLink = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'TagWithLink',
    text: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    url: '',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const inputHandler = (e) => {
    const { value, name, lang } = e.target;

    const { component } = components[index];
    let comp = {};
    if (name === 'text') {
      comp = {
        ...component,
        [name]: {
          ...component[name],
          [lang.toLowerCase()]: value,
        },
      };
    } else {
      comp = {
        ...component,
        [name]: value,
      };
    }

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      console.log('TCL: components[componentIndex]', components[componentIndex]);

      if (component) {
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  return (
    <div className="w-full bg-greyFilter rounded-r flex flex-row items-center">
      {languages.map(lang => (
        <div key={lang} className={`w-1/2 ${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} ${slider ? 'ml-7 pr-1 mt-0 pb-5px' : 'p-4'}`}>
          <label htmlFor="text" className={`text-xxs uppercase ${slider ? 'pl-1 text-black' : 'pl-3'}`}>
            Text
          </label>
          <input className={`font-americaMonoRegular bg-white outline-none w-full ${slider ? 'p-1 rounded-full text-sm pl-4' : ' ml-4 p-2'}`} onChange={inputHandler} name="text" lang={lang} type="text" value={state.text[lang.toLowerCase()]} readOnly={reusableComponent && reusableComponent} />
        </div>
      ))}
      <div className="w-1/2 pr-3 pb-1">
        <label htmlFor="url" className={`text-xxs uppercase ${slider ? 'pl-1 text-black' : 'pl-3'}`}>
          Url
        </label>
        <input className={`font-americaMonoRegular bg-white outline-none w-full ${slider ? 'p-1 rounded-full text-sm' : ' ml-4 p-2'}`} onChange={inputHandler} name="url" type="X" value={state.url} readOnly={reusableComponent && reusableComponent} />
      </div>
    </div>
  );
};

TagWithLink.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
TagWithLink.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default TagWithLink;
